import { useState } from "react";
import { Leaf } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Tappable Ingredients-Mi chips on protocol cards. Tapping opens a small
// education card (name, feature, benefit, photo) — all from Airtable.
export default function IngredientChips({ chips = [], productId, max = 6 }) {
  const [showAll, setShowAll] = useState(false);
  if (!chips.length) return null;
  const visible = showAll ? chips : chips.slice(0, max);
  return (
    <div data-testid={`ingredient-chips-${productId}`}>
      <div className="text-[10px] uppercase tracking-wide text-zinc-400 font-semibold mb-1 inline-flex items-center gap-1">
        <Leaf size={10} /> Ingredients
      </div>
      <div className="flex flex-wrap gap-1">
        {visible.map((c) => (
          <Popover key={c.id}>
            <PopoverTrigger asChild>
              <button
                type="button"
                className="rounded-full border border-emerald-200 bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-800 hover:bg-emerald-600 hover:text-white hover:border-emerald-600 transition-colors"
                data-testid={`ingredient-chip-${c.id}`}
              >
                {c.name}
              </button>
            </PopoverTrigger>
            <PopoverContent className="w-72 p-0 overflow-hidden rounded-2xl" data-testid={`ingredient-popover-${c.id}`}>
              {c.image_url && (
                <img src={c.image_url} alt={c.name} className="w-full h-28 object-cover" loading="lazy" onError={(e) => (e.currentTarget.style.display = "none")} />
              )}
              <div className="p-3">
                <div className="text-[10px] uppercase tracking-wide text-emerald-700 font-bold">Ingredient</div>
                <div className="text-sm font-bold text-zinc-900 mt-0.5">{c.name}</div>
                {c.feature && <p className="text-xs text-zinc-700 mt-1.5 leading-relaxed">{c.feature}</p>}
                {c.benefit && (
                  <p className="text-xs text-zinc-600 mt-1.5 leading-relaxed">
                    <span className="font-semibold text-zinc-800">Benefit: </span>{c.benefit}
                  </p>
                )}
              </div>
            </PopoverContent>
          </Popover>
        ))}
        {chips.length > max && (
          <button type="button" onClick={() => setShowAll((v) => !v)} className="text-[11px] text-zinc-500 hover:text-zinc-900 px-1" data-testid={`ingredient-chips-more-${productId}`}>
            {showAll ? "Show less" : `+${chips.length - max} more`}
          </button>
        )}
      </div>
    </div>
  );
}
